import apiClient from '@u/apiClient'
import GetAccountingDiariesListForExportController from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/GetAccountingDiariesListForExportController'
import AccountingExportController from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/AccountingExportController'
import AccountingExportPDFController from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/AccountingExportPDFController'
import GetBankAccountsListForExportController from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/GetBankAccountsListForExportController'
import BankAccountExportController from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/BankAccountExportController'
import InvoiceExportUnpaid from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/InvoiceExportUnpaid'
import InvoiceExportSalesJournal from '@/wayfinder/actions/App/Http/Controllers/InvoiceExport/InvoiceExportSalesJournal'
import InvoiceExportController from '@/wayfinder/actions/App/Http/Controllers/Invoice/InvoiceExportController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}
export default {
  fetchAccountingDiaryListForExport({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAccountingDiariesListForExportController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  exportInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(AccountingExportController.post(), payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  exportPDFInvoice: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(AccountingExportPDFController.get(), { params: payload.data })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchBankAccountListForExport({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetBankAccountsListForExportController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  exportTreasury: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(BankAccountExportController.post(), payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  exportUnpaid: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(InvoiceExportUnpaid.post(), payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  exportSalesJournal: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(InvoiceExportSalesJournal.post(), payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  invoiceExportExcel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(InvoiceExportController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  thirdPartyCostExportExcel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/api/third-party-cost/export-excel`, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
